var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-flex items-center gap-1.5"},[_c('z-icon',{attrs:{"icon":_vm.icon,"color":_vm.color,"size":"x-small.5"}}),_vm._v(" "),_c('span',{staticClass:"text-sm font-normal leading-none text-vanilla-100"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }